import { useState, useCallback, useEffect, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@reducers/index';
import { tabList } from '@models/ranking/ranking';
import { setTabValue, addSelectCategory, delSelectCategory, setSelectCategory } from '@reducers/ranking/rankingSlice';
import { RankingChartOption } from '@classes/options/chart/rankingChartOption';
import { RankingGridOption } from '@classes/options/grid/rankingGridOption';
import GridClickColorAtom from '@components/atom/grid/gridClickColor';
import LineChartAtom from '@components/atom/chart/line';
import { LineChartDataModel } from '@models/highChartsModel';

const GridChartBox = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { categoryRankings, categoryTabValue, categoriesSelected, isLoadingCategoryRankings } = useSelector(
    ({ ranking }: RootState) => ranking
  );

  // state for Chart
  const [highChartData, setHighChartData] = useState<LineChartDataModel>(null);
  const [gridChartData, setGridChartData] = useState(null);

  // chartOptions
  const _highChartOption = new RankingChartOption();
  const _gridChartOption = new RankingGridOption();

  // initial responseData handling
  useEffect(() => {
    if (categoryRankings) {
      setHighChartData(_highChartOption.categoryRankings(categoryRankings[categoryTabValue], []));
      setGridChartData(_gridChartOption.categoryRankings(categoryRankings[categoryTabValue], []));
      // selectedCategories 초기화 처리
      dispatch(setSelectCategory({ categoryList: [] }));
    }
  }, [categoryRankings]);

  // useEffect for TabValue
  useEffect(() => {
    // selectedCategories 초기화 처리
    dispatch(setSelectCategory({ categoryList: [] }));
    if (categoryRankings) {
      setHighChartData(_highChartOption.categoryRankings(categoryRankings[categoryTabValue], []));
      setGridChartData(_gridChartOption.categoryRankings(categoryRankings[categoryTabValue], []));
    }
  }, [categoryTabValue]);

  // useEffect for selectedCategories
  useEffect(() => {
    if (categoryRankings) {
      setHighChartData(_highChartOption.categoryRankings(categoryRankings[categoryTabValue], categoriesSelected));
      setGridChartData(_gridChartOption.categoryRankings(categoryRankings[categoryTabValue], categoriesSelected));
    }
  }, [categoriesSelected]);

  // onClickTabValue
  const onClickTabValue = useCallback(
    (tabCode) => {
      dispatch(setTabValue({ tabValue: tabCode }));
    },
    [dispatch, setTabValue]
  );

  // gridChart Row Click handler
  const handleGridChartRowClick = useCallback(
    (event) => {
      const { property } = event;
      if (categoriesSelected.includes(property)) {
        dispatch(delSelectCategory({ category: property }));
      } else {
        dispatch(addSelectCategory({ category: property }));
      }
    },
    [categoriesSelected, dispatch, addSelectCategory, delSelectCategory]
  );

  return (
    <div className="chart-tab">
      <div className="chart-tab-wrap">
        <div className="chart-tab-inner">
          <ul className="chart-tab-box">
            {tabList.map((tab, index) => (
              <li key={index}>
                <input
                  type="radio"
                  id={`tab-${tab.code}`}
                  className="tab-radio"
                  value={tab.code}
                  checked={tab.code === categoryTabValue ? true : false}
                  onChange={() => onClickTabValue(tab.code)}
                />
                <label htmlFor={`tab-${tab.code}`}>{tab.text}</label>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="chart-tab-conts active">
        <div className="chart-tab-api">
          {/* 하이차트 */}
          <div className="high-chart">
            <LineChartAtom chartData={highChartData} height="400px" isLoading={isLoadingCategoryRankings} />
          </div>
          <br />
          {/* 그리드차트 */}
          <div className="grid-chart">
            <GridClickColorAtom
              {...gridChartData}
              rowClickHandler={handleGridChartRowClick}
              categoriesSelected={categoriesSelected}
              height="600px"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GridChartBox;
